import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../Translations';
import ModalStore from '../../../../../Modal/Store';
import ProductLicense from '../../../Edit/CurrentCollectionStep/Builder/ProductLicense';
import LearningCollectionEditStore from '../../../Edit/Store';
import { CustomizeState } from '../../../Edit/Store/Types';
import LegacyAddOns from './LegacyAddOns';

interface Props {
  store: LearningCollectionEditStore;
  state: CustomizeState;
  execonlineCatalogModalStore: ModalStore;
  videoProjectFeedbackModalStore: ModalStore;
  warnUser: () => boolean;
}

const AddOns: React.FC<Props> = ({
  store,
  state,
  warnUser,
  execonlineCatalogModalStore,
  videoProjectFeedbackModalStore,
}) => (
  <div className="w-full">
    <p className="text-gray-700">
      <T kind="Enhance your collection..." />
    </p>
    <p className="mt-4 text-sm font-semibold text-gray-700">
      <T kind="Features" />
    </p>
    <div className="mt-2 flex flex-col gap-2 w-full">
      <LegacyAddOns
        store={store}
        execonlineCatalogModalStore={execonlineCatalogModalStore}
        videoProjectFeedbackModalStore={videoProjectFeedbackModalStore}
        warnUser={warnUser}
      />
      <ProductLicense store={store} state={state} />
    </div>
  </div>
);

export default observer(AddOns);
